document.addEventListener("DOMContentLoaded", function () {
  const cartBtns = document.querySelectorAll(".sp_cart_btn, .favoorite_btn");
  const variationCart = document.querySelector(".variation_cart");
  const closeBtns = document.querySelectorAll(".variation_cart_close, .variation_cart_close2");
  const header = document.querySelector(".shopify-section--header");
  const body = document.querySelector("body");

  cartBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        body.classList.add("pop");
        variationCart.classList.add("active");
        header && header.classList.add("hidden");
      }
    });
  });
  closeBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (variationCart) {
        variationCart.classList.remove("active");
        header && header.classList.remove("hidden");
        body.classList.remove("pop");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector('.sp_button');
  const fixedBtn = document.querySelector('.sp_cart_btn_fixed_wrap');

  if (!target || !fixedBtn) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      const targetTop = target.getBoundingClientRect().top + window.scrollY;

      if (!entry.isIntersecting && window.scrollY > targetTop) {
        fixedBtn.classList.add('active');
      } else {
        fixedBtn.classList.remove('active');
      }
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(target);
});


document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.header-sidebar__linklist-button-child');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const targetUl = this.nextElementSibling;

      if (targetUl && targetUl.classList.contains('header-sidebar__submenu')) {
        const isOpen = this.classList.contains('is-open');

        this.classList.toggle('is-open', !isOpen);
        this.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        targetUl.classList.toggle('is-open', !isOpen);
      }
    });
  });
});

document.addEventListener('click', function (event) {
  const button = event.target.closest('.multi__next-section-button');
  if (!button) return;
  const currentSection = button.closest('.shopify-section');
  if (!currentSection) return;
  let nextSection = currentSection.nextElementSibling;
  while (nextSection && !nextSection.classList.contains('shopify-section')) {
    nextSection = nextSection.nextElementSibling;
  }

  if (!nextSection) return;
  const header = document.querySelector('header');
  const headerHeight = header ? header.offsetHeight : 0;
  const top = nextSection.getBoundingClientRect().top + window.pageYOffset - headerHeight;

  window.scrollTo({
    top,
    behavior: 'smooth'
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const isSP = () => window.matchMedia('(max-width: 699px)').matches;

  const parents = document.querySelectorAll('.footer-brand-menu .pa');

  parents.forEach(parent => {
    parent.addEventListener('click', (e) => {
      if (!isSP()) return;

      const li = parent.closest('li');
      const child = li.querySelector('.child');
      if (!child) return;

      e.preventDefault();

      const isOpen = li.classList.contains('is-open');

      if (isOpen) {
        child.style.height = child.scrollHeight + 'px';
        requestAnimationFrame(() => {
          child.style.height = '0px';
        });
        li.classList.remove('is-open');

      } else {
        child.style.height = child.scrollHeight + 'px';
        li.classList.add('is-open');

        child.addEventListener('transitionend', function handler() {
          child.style.height = 'auto';
          child.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});

//TOP アニメーション
window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
});

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.js-mask-text');

  if (!targets.length) return;

  targets.forEach((target) => {
    setTimeout(() => {
      target.classList.add('is-active');
    }, 1200);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.multi-column-custom .multi-column__item');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('is-show');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0,
    rootMargin: '0px 0px 10% 0px'
  });

  items.forEach(el => observer.observe(el));
});

//カートボタン送信時に、variant meta preorder_date を更新する
document.addEventListener('submit', async function(e) {
  const form = e.target;

  const checkoutButton = form.querySelector('[name="checkout"]');
  if (!checkoutButton) return;
  if (form.dataset.shippingUpdated === 'true') return;

  e.preventDefault();
  const cart = await fetch('/cart.js').then(res => res.json());

  for (const item of cart.items) {
    const el = document.querySelector(
      `.cart-item-shipping-time[data-line-key="${CSS.escape(item.key)}"]`
    );

    if (!el) continue;
    const currentShippingTime = el.dataset.shippingTime || '';
    const properties = item.properties || {};
    properties['発送予定時期'] = currentShippingTime;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties: properties
      })
    });
  }

  form.dataset.shippingUpdated = 'true';
  checkoutButton.click();
});